import { Model } from '@vuex-orm/core';

export class CompanyCompanyType extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'company_company_types';

  static primaryKey = ['company_id', 'company_type_code'];

  static fields() {
    return {
      company_id: this.attr(null),
      company_type_code: this.attr(null),
    };
  }
}

export default CompanyCompanyType;
